// import functions from API
import { i18n } from 'i18n';
import {
  InvitationDto,
  InviteUserToTeamsCommand,
  PagedListOfInvitationDto
} from './api';
import {
  makeCreateMutation,
  makeDeleteMutation,
  makeListQuery,
  PageParams
} from './useApi';

const INVITES_KEY = 'invitations';
export interface InvitationsQueryParams extends PageParams {
  searchTerm?: string | null;
  clientId?: string | null;
}

// GET Multiple invites
export const useInvitationsQuery = makeListQuery<InvitationsQueryParams, PagedListOfInvitationDto>(
  INVITES_KEY,
  (api, params) => () => api.invitations.listInvitations(params.page, params.pageSize, params.clientId, null, params.searchTerm),
);

const INVITE_KEY = 'invite';

export const useCreateInviteMutation = makeCreateMutation<void, InviteUserToTeamsCommand>(
  INVITE_KEY,
  (api) => (mutation) => api.invitations.create(mutation),
  (mutation) => i18n._('Invite successfully sent to ').concat(` ${mutation.email}`),
);

export const useRevokeInvitationMutation = makeDeleteMutation<void, InvitationDto>(
  INVITE_KEY,
  INVITES_KEY,
  (api) => (invite) => api.invitations.revokeInvitation(invite.invitationId),
  (invite) => i18n._('Invite for').concat(` ${invite.email} `).concat(i18n._('successfully revoked')),
  (mutation) => mutation.invitationId,

);
